import produce from 'immer'

const initialState = {
  propertyChecklistDismissed: false,
  descriptionForReviewDismissedAt: {},
  infoBarDismissedAt: {},
  roomImageManagementWhatsNew: {},
}

const preferences = produce((draft = initialState, action) => {
  draft.descriptionForReviewDismissedAt ??= {}
  draft.infoBarDismissedAt ??= {}
  draft.roomImageManagementWhatsNew ??= {}
  switch (action.type) {
    case 'PREFERENCES_PROPERTY_CHECKLIST_DISMISS':
      draft.propertyChecklistDismissed = true
      return draft
    case 'PREFERENCES_DESCRIPTION_FOR_REVIEW_DISMISS':
      draft.descriptionForReviewDismissedAt[action.userId] = Date.now()
      return draft
    case 'PREFERENCES_INFOBAR_DISMISS':
      draft.infoBarDismissedAt[action.userId] ??= {}
      draft.infoBarDismissedAt[action.userId][action.infoId] = Date.now()
      return draft
    case 'PREFERENCES_ROOM_IMAGE_MANAGEMENT_WHATS_NEW_DISMISS': {
      const existing = draft.roomImageManagementWhatsNew[action.userId] ?? {
        dismissedAt: null,
        skipCount: 0,
        permanentlyDismissed: false,
      }
      draft.roomImageManagementWhatsNew[action.userId] = {
        dismissedAt: Date.now(),
        skipCount: existing.skipCount + 1,
        permanentlyDismissed: action.permanent || existing.permanentlyDismissed,
      }
      return draft
    }
    default:
      return draft
  }
})

export default preferences
